// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DiffTwoToneSvg from "@fishx/icons-svg/es/asn/DiffTwoTone";
import FishxIcon from '../components/FishxIcon';

var DiffTwoTone = function DiffTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DiffTwoToneSvg
  }));
};

DiffTwoTone.displayName = 'DiffTwoTone';
export default React.forwardRef(DiffTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DiffTwoTone.js
// module id = 2418
// module chunks = 0